export default "__VITE_ASSET__BzrJeHrA__"